import React from 'react';
import { connect } from 'react-redux';
import { PCCCategories, PCCCategoryIds } from '_constants';
import { PatientHomeAdmissions } from 'PatientCareCenter/Home/Admissions';
import { PatientHomeCdv } from 'PatientCareCenter/Home/Cdv';
import { PatientHomeDiary } from 'PatientCareCenter/Home/Diary';
import { PatientHomeScanStation } from 'PatientCareCenter/Home/ScanStation';
import { PatientHomeApptHistory } from 'PatientCareCenter/Home/ApptHistory';
import { PatientHomePeerReviews } from 'PatientCareCenter/Home/PeerReviews';
import styles from './PatientContent.module.css';


class PatientContent extends React.Component {

    render() {
        switch (this.props.selectedHomeCategory) {
            case PCCCategories[PCCCategories.findIndex(obj => obj.id === PCCCategoryIds.ADMISSIONS)].id:
                return (<div className={styles.content}><PatientHomeAdmissions /></div>);
            case PCCCategories[PCCCategories.findIndex(obj => obj.id === PCCCategoryIds.CDV)].id:
                return (<div className={styles.content}><PatientHomeCdv /></div>);
            case PCCCategories[PCCCategories.findIndex(obj => obj.id === PCCCategoryIds.DIARY)].id:
                return (<div className={styles.content}><PatientHomeDiary /></div>);
            case PCCCategories[PCCCategories.findIndex(obj => obj.id === PCCCategoryIds.SCAN_STATION)].id:
                return (<div className={styles.content}><PatientHomeScanStation /></div>);
            case PCCCategories[PCCCategories.findIndex(obj => obj.id === PCCCategoryIds.APPT_HISTORY)].id:
                return (<div className={styles.content}><PatientHomeApptHistory /></div>);
            case PCCCategories[PCCCategories.findIndex(obj => obj.id === PCCCategoryIds.PEER_REVIEWS)].id:
                return (<div className={styles.content}><PatientHomePeerReviews /></div>);
            default:
                return (<div className={styles.content}><PatientHomeAdmissions /></div>);
        }
    }
}

function mapStateToProps(state) {
    return {
        selectedHomeCategory: state.ui.patientCenter[state.ui.patients.selectedPtno].selectedHomeCategory
    };
}

const connectedPatientContent = connect(mapStateToProps)(PatientContent);
export { connectedPatientContent as PatientContent };
